import React from "react";
import PropTypes from "prop-types";
import { Detail, DetailTable } from "../DetailTable";

export function PhysicalAddress({ address }) {
  return (
    <DetailTable>
      <Detail label="Address Line" value={address.line1} />
      <Detail label="City" value={address.city} />
      <Detail label="State/ Province/ Region" value={address.state} />
      <Detail label="ZIP/ Postal Code" value={address.postal_code} />
      <Detail label="Country" value={address.country} />
    </DetailTable>
  );
}

PhysicalAddress.propTypes = {
  address: PropTypes.shape({
    line1: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postal_code: PropTypes.string,
    country: PropTypes.string
  })
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/PhysicalAddress/PhysicalAddress.jsx